export enum ErrorStatus {
	ERR_NETWORK = "ERR_NETWORK",
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
}
